export default __webpack_public_path__ + "static/media/logo.243f48da.png";